import { connect } from "react-redux";
import * as React from "react";
import { Link } from "react-router-dom";

class Logo extends React.Component {
    render() {

        const { activeProfile, containerClass, currentPharmacyUser, serverData } = this.props;
        const hasPatient = activeProfile && activeProfile.patient;
        const isPharmacyBundle = serverData && serverData.bundle && serverData.bundle.toLowerCase() === 'pharmacy' ? true : false;

        //debugger;
        return (
            <div className={containerClass}>
                <Link onClick={event => { if (event.ctrlKey && window.serverData.data.environment !== "PROD") { window.alert(`Currently running build from the (${document.querySelector("body").getAttribute("data-version")}) branch. If null then view source and check the bottom of the body element to see version`); } }} to={{ pathname: isPharmacyBundle && currentPharmacyUser && currentPharmacyUser.pharmacyPatientId ? '/pharmacy' : '/' }}>
                    <img alt="MyBSWHealth" className="bswh-header-logo--desktop" src="/images/mybswlogo.svg" />
                    <img alt="MyBSWHealth" className="bswh-header-logo--mobile" src="/images/bswh_logo.svg" />
                </Link><br />
            </div>
        );
    }



}

const mapStateToProps = (state) => {
    //debugger;

    const windowDefined = typeof window !== 'undefined';
    //console.log("Dashboard.mappingStateToProps... state = " + JSON.stringify( state));

    return {
        activeProfile: state.memberships.activeProfile,
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Logo);